import { css } from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';
import { Breakpoint } from '../../styles/constants';
import { TextProps } from './Heading/Heading.styles';
import { StyledLoading } from './Paragraph/Paragraph';
import { typeConfig } from './typeConfig';

export const getTypeConfig = <T extends TextProps>(key: keyof typeof typeConfig) => (props: T) => {
  if (!(key in typeConfig)) return null;
  const { size, lineHeight, fontWeight } = typeConfig[key] || {};
  return css`
    color: ${props.inverted ? ThemeColours.white : ThemeColours.mono900};
    font-size: ${size?.lowRes};
    font-weight: ${props.weight ? props.weight : fontWeight};
    line-height: ${lineHeight?.lowRes};
    margin-bottom: calc(${size?.lowRes} / 1.6);

    ${StyledLoading} {
      height: ${size?.lowRes};
    }

    ${Breakpoint.SMALL} {
      font-size: ${props.small ? size?.lowRes : size?.highRes};
      line-height: ${props.small ? lineHeight?.lowRes : lineHeight?.highRes};
      margin-bottom: calc(${props.small ? size?.lowRes : size?.highRes} / 1.6);

      ${StyledLoading} {
        height: ${props.small ? size?.lowRes : size?.highRes};
      }
    }
  `;
};
